import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Verify from "@/pages/Verify";
import PropertyDetail from "@/pages/PropertyDetail";
import SearchDetail from "@/pages/SearchDetail";
import Contatti from "@/pages/Contatti";
import Network from "@/pages/Network";
import ComeFunziona from "@/pages/ComeFunziona";
import AuthCallback from "@/components/AuthCallback";
import { Toaster } from "@/components/ui/sonner";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/properties/:id" element={<PropertyDetail />} />
      <Route path="/searches/:id" element={<SearchDetail />} />
      <Route path="/contatti" element={<Contatti />} />
      <Route path="/network" element={<Network />} />
      <Route path="/come-funziona" element={<ComeFunziona />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-[Outfit,sans-serif] bg-[#F5F0E6]">
      <BrowserRouter>
        <AppProvider>
          <AppRoutes />
          <Toaster theme="light" position="top-right" />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
